<template>
  <div
    class="modal modal-bottom fade"
    id="bottom_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="bottom_modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <!-- MBR theme 2 — "Confirm Purchase" sheet in member_app_UI/song_fa_members_rewards_store_mobile -->
      <div class="modal-content mbr-ex">
        <div class="mbr-ex__top">
          <span class="mbr-ex__handle" aria-hidden="true"></span>
          <!-- MBR046: bundles are bought from the Store, single rewards are exchanged -->
          <h3 class="mbr-ex__title">
            {{ voucherData.is_bundle ? $t('reward.confirm_purchase') : $t('reward.confirm_exchange_title') }}
          </h3>
          <!-- keep .btn-close: handleSelectPay() and the views close sheets with $(".btn-close").click() -->
          <button type="button" class="btn-close mbr-ex__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div class="modal-body mbr-ex__body">
          <div class="mbr-ex__options">
            <!-- Option 1: Use Wallet -->
            <label
              v-if="rewardPerTransaction == 1"
              class="mbr-ex__option"
              :class="{ 'mbr-ex__option--on': picked === 'One', 'mbr-ex__option--off': voucherData.is_disabled }"
            >
              <input
                type="radio"
                id="payment-wallet"
                name="payment-exchange"
                value="One"
                v-model="picked"
                :disabled="voucherData.is_disabled"
              />
              <span>{{ $t('reward.use_wallet') }}</span>
            </label>

            <!-- Option 1: Use Points -->
            <label
              v-else-if="
                rewardPerTransaction == 2 &&
                (!voucherData.is_bundle || voucherData.points_convert > 0)
              "
              class="mbr-ex__option"
              :class="{ 'mbr-ex__option--on': picked === 'One', 'mbr-ex__option--off': voucherData.is_disabled }"
            >
              <input
                type="radio"
                id="payment-points"
                name="payment-exchange"
                value="One"
                v-model="picked"
                :disabled="voucherData.is_disabled"
              />
              <span>{{ $t('reward.use_x', { name: voucherData.point_name }) }}</span>
            </label>

            <!-- Option 2: Pay by Card -->
            <label
              v-if="voucherData.is_bundle"
              class="mbr-ex__option"
              :class="{ 'mbr-ex__option--on': picked === 'Two', 'mbr-ex__option--off': voucherData.is_disabled_by_card }"
            >
              <input
                type="radio"
                id="payment-card"
                name="payment-exchange"
                value="Two"
                v-model="picked"
                :disabled="voucherData.is_disabled_by_card"
              />
              <span>{{ $t('reward.pay_by_card') }}</span>
            </label>
          </div>

          <!-- Wallet / Points detail panel -->
          <div v-if="picked === 'One' && !voucherData.is_disabled" class="mbr-ex__panel">
            <div class="mbr-ex__voucher">
              <img :src="voucherData.icon_url" class="mbr-ex__voucher-img" :alt="$t('reward.voucher')" />
              <div class="mbr-ex__voucher-body">
                <h4 class="mbr-ex__voucher-title">{{ voucherData.reward_title ?? "" }}</h4>
                <p class="mbr-ex__voucher-meta">{{ validityText(voucherData.expiry_date_text) }}</p>
                <span
                  v-if="voucherData.is_bundle && voucherData.number_of_vouchers_text"
                  class="mbr-ex__voucher-pill"
                >
                  {{ voucherCountText(voucherData) }}
                </span>
              </div>
            </div>

            <template v-if="rewardPerTransaction != 0">
              <div class="mbr-ex__row">
                <span>
                  {{
                    $t('reward.total_x', {
                      name: rewardPerTransaction == 1 ? $t('home.wallet') : voucherData.point_name,
                    })
                  }}
                </span>
                <strong class="mbr-ex__strong">
                  {{
                    rewardPerTransaction == 1 ? amount_format : point_format
                  }}
                </strong>
              </div>

              <div class="mbr-ex__row">
                <span>
                  {{
                    rewardPerTransaction == 1
                      ? $t('reward.payment_amount')
                      : $t('reward.payment_x', { name: voucherData.point_name })
                  }}
                </span>
                <span>
                  {{
                    rewardPerTransaction == 1
                      ? voucherData.amount_text
                      : voucherData.point_text
                  }}
                </span>
              </div>

              <div class="mbr-ex__row mbr-ex__row--total">
                <span>{{ $t('reward.balance') }}</span>
                <strong
                  v-if="rewardPerTransaction == 1"
                  class="mbr-ex__total"
                  :class="{ 'mbr-ex__total--negative': walletBalanceAfter < 0 }"
                >
                  ${{ formattedWalletBalance }}
                </strong>
                <strong
                  v-else
                  class="mbr-ex__total"
                  :class="{
                    'mbr-ex__total--negative':
                      voucherData.points_convert > point_in_account,
                  }"
                >
                  {{
                    formatPoint(point_in_account - voucherData.points_convert)
                  }}
                </strong>
              </div>
            </template>
          </div>

          <!-- Card payment detail panel -->
          <div v-else-if="picked === 'Two' && !voucherData.is_disabled_by_card" class="mbr-ex__panel">
            <!-- MBR046: the design's summary row — the card panel used to jump
                 straight into the amount rows with no sight of what is bought -->
            <div class="mbr-ex__voucher">
              <img :src="voucherData.icon_url" class="mbr-ex__voucher-img" :alt="$t('reward.voucher')" />
              <div class="mbr-ex__voucher-body">
                <h4 class="mbr-ex__voucher-title">{{ voucherData.reward_title ?? "" }}</h4>
                <p class="mbr-ex__voucher-meta">{{ validityText(voucherData.expiry_date_text) }}</p>
                <span
                  v-if="voucherData.is_bundle && voucherData.number_of_vouchers_text"
                  class="mbr-ex__voucher-pill"
                >
                  {{ voucherCountText(voucherData) }}
                </span>
              </div>
              <span class="mbr-ex__voucher-price">{{ voucherData.amount_text }}</span>
            </div>

            <p class="mbr-ex__section">{{ $t('reward.transaction_detail') }}</p>

            <div class="mbr-ex__row">
              <span>{{ $t('reward.item') }}</span>
              <span class="mbr-ex__value">{{ voucherData.reward_title ?? "" }}</span>
            </div>
            <div class="mbr-ex__row">
              <span>{{ $t('reward.item_price') }}</span>
              <span>{{ voucherData.amount_text }}</span>
            </div>
            <div class="mbr-ex__row">
              <span>{{ $t('reward.tax') }}</span>
              <span>$ 0</span>
            </div>
            <div class="mbr-ex__row">
              <span>{{ $t('reward.transaction_fee') }}</span>
              <span>$ 0</span>
            </div>
            <div class="mbr-ex__row mbr-ex__row--total">
              <span>{{ $t('reward.total_amount') }}</span>
              <strong class="mbr-ex__total">{{ voucherData.amount_text }}</strong>
            </div>

            <p
              v-if="snackbar === 'danger' || snackbar === 'success'"
              class="mbr-ex__error"
            >
              {{ message }}
            </p>
          </div>
        </div>

        <div
          class="mbr-ex__actions"
          v-if="!voucherData.is_disabled_by_card || !voucherData.is_disabled"
        >
          <button type="button" class="mbr-ex__cta" @click="handleSelectPay">
            {{ picked === "Two" ? $t('reward.continue_to_payment') : $t('reward.proceed') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <material-loading :active="loaderActive" />
</template>

<script>
import StripeService from "../services/stripe.service.js";
import AirwallexService from "../services/airwallex.service.js";
import MemberService from "../services/member.service.js";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import { voucherCountText, validityText } from "@/i18n/apiText";
import { errorMessage } from "@/utils/errorMessage";

const PAYMENT_MODE_STRIPE = 1;
const PAYMENT_MODE_AIRWALLEX = 3;

export default {
  name: "Exchange",

  components: {
    MaterialLoading,
  },

  props: {
    keyReload: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    voucherData: {
      type: Object,
      required: true,
    },
    rewardPerTransaction: {
      type: Number,
      default: 0,
    },
    amount_format: {
      type: String,
      required: true,
    },
    amount_in_account: {
      type: String,
      default: "",
    },
    point_format: {
      type: String,
      required: true,
    },
    point_in_account: {
      type: Number,
      default: 0,
    },
    confirmExchange: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      picked: "One",
      message: "",
      snackbar: null,
      loaderActive: false,
      memberInfo: {},
      // Merchant's preferred gateway for card payments (1 = Stripe, 3 = Airwallex).
      // Fetched lazily on first reload; cached for the component's lifetime.
      defaultPaymentMode: PAYMENT_MODE_STRIPE,
      defaultPaymentModeLoaded: false,
    };
  },

  computed: {
    walletBalanceAfter() {
      return (
        parseFloat(this.amount_in_account) -
        parseFloat(this.voucherData.amount_convert)
      );
    },
    formattedWalletBalance() {
      return new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(this.walletBalanceAfter);
    },
  },

  watch: {
    keyReload(val) {
      if (val) {
        this.picked =
          this.rewardPerTransaction == 0 ||
          (this.rewardPerTransaction == 2 &&
            this.voucherData.points_convert == 0)
            ? "Two"
            : "One";

        // Lazy fetch — only the first time the modal opens.
        if (!this.defaultPaymentModeLoaded) {
          // Kept so handleSelectPay can wait for it on a quick click.
          this.paymentModeRequest = MemberService.getDefaultPaymentMode().then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.defaultPaymentMode =
                  parseInt(response.data.data.default_payment_mode) ||
                  PAYMENT_MODE_STRIPE;
              }
              this.defaultPaymentModeLoaded = true;
            },
            () => {
              // Fall back to Stripe on error — same as existing behaviour.
              this.defaultPaymentModeLoaded = true;
            }
          );
        }
      }
    },
  },

  methods: {
    validityText,
    voucherCountText,
    formatPoint(point) {
      return `${point} ${this.voucherData.point_name}`;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    async handleSelectPay() {
      $(".btn-close").click();

      if (this.picked === "One") {
        this.confirmExchange();
        return;
      }

      this.showLoader();

      // Until the gateway lookup resolves, defaultPaymentMode is still the
      // Stripe default — an Airwallex merchant would be sent to Stripe.
      if (!this.defaultPaymentModeLoaded && this.paymentModeRequest) {
        await this.paymentModeRequest;
      }

      const { origin, pathname } = window.location;
      const cancelUrl = `${origin}${pathname}`;
      const useAirwallex = this.defaultPaymentMode === PAYMENT_MODE_AIRWALLEX;

      // Airwallex post-payment confirmation is centralised in Store.vue, so
      // redirect there regardless of which parent (Bundle detail, Reward,
      // Landing…) opened the Exchange modal. Stripe stays put because each
      // parent has its own server-side completion endpoint.
      const merchantCode = this.$store.state.merchantCode;
      const airwallexReturn = `${origin}/${merchantCode}/store`;

      // Stripe substitutes {CHECKOUT_SESSION_ID} in the redirect URL; Airwallex
      // HPP doesn't, so the BE appends `?airwallex_intent_id=` to whatever we
      // pass as success_url.
      const successUrl = useAirwallex
        ? `${airwallexReturn}?reward_id=${this.voucherData.id}`
        : `${cancelUrl}?session_id={CHECKOUT_SESSION_ID}&reward_id=${this.voucherData.id}`;

      const dataSend = {
        member_id: this.voucherData.member_id ?? 0,
        success_url: successUrl,
        cancel_url: cancelUrl,
        images: this.voucherData.icon_url ?? "",
        voucher_id: this.voucherData.id ?? 0,
        name: this.voucherData.reward_title ?? "",
        unit_amount: this.voucherData.amount_convert ?? 0,
        quantity: 1,
      };

      if (this.voucherData.is_bundle) {
        dataSend.isExchangeVoucherBundle = 1;
      } else {
        dataSend.isExchangeVoucher = 1;
      }

      // While the Airwallex SDK loads the payment page, keep the loader up so
      // the sheet can't be used to start a second payment.
      let leavingForAirwallex = false;

      try {
        const response = useAirwallex
          ? await AirwallexService.checkoutHppAirwallex(
              dataSend,
              this.$store.state.merchantCode
            )
          : await StripeService.checkoutSessionStripe(dataSend);

        if (response.data.result.isSuccess) {
          if (useAirwallex) {
            leavingForAirwallex = true;
            await AirwallexService.redirectToHpp(response.data.data, () => this.hideLoader());
          } else {
            const redirectUrl = response.data.data.url;
            window.location.assign(redirectUrl);
          }
        } else {
          this.snackbar = "danger";
          this.message = errorMessage(response.data.result.message);
        }
      } catch (error) {
        leavingForAirwallex = false;
        this.snackbar = "danger";
        this.message = errorMessage(error, 'reward.payment_error');
      } finally {
        if (!leavingForAirwallex) {
          this.hideLoader();
        }
      }
    },
  },
};
</script>

<style scoped>
/* MBR theme 2 exchange sheet. Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-ex {
  max-height: 90vh;
  padding: 12px 24px 28px;
  background: var(--mbr-color-surface);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
}

.mbr-ex__top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 36px;
  padding-top: 12px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-ex__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-strong);
}

.mbr-ex__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-ex__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
}

.mbr-ex__close svg {
  width: 16px;
  height: 16px;
}

.modal.modal-bottom .modal-body.mbr-ex__body {
  padding: 8px 0 20px;
}

.mbr-ex__options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mbr-ex__option {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 8px 16px;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

/* the radio stays in the DOM (v-model, disabled) but the pill is the visual */
.mbr-ex__option input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.mbr-ex__option:focus-within {
  box-shadow: 0 0 0 3px rgba(var(--mbr-color-primary-rgb), 0.15);
}

.mbr-ex__option--on {
  background: var(--mbr-color-primary);
  border-color: var(--mbr-color-primary);
  font-family: var(--mbr-font-headline);
  font-weight: 700;
  color: var(--mbr-color-on-primary);
}

.mbr-ex__option--off {
  opacity: 0.5;
  cursor: not-allowed;
}

.mbr-ex__panel {
  margin-top: 16px;
}

.mbr-ex__voucher {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px;
  background: var(--mbr-color-canvas);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.7);
  border-radius: var(--mbr-radius-lg);
}

.mbr-ex__voucher-img {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  object-fit: cover;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-md);
}

.mbr-ex__voucher-body {
  min-width: 0;
}

/* font-family/color set explicitly: Material Dashboard styles h4 */
.mbr-ex__voucher-title {
  margin: 0;
  overflow: hidden;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: normal;
  color: var(--mbr-color-ink-strong);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mbr-ex__voucher-meta {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-ex__voucher-pill {
  display: inline-block;
  margin-top: 4px;
  padding: 1px 8px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-primary);
}

.mbr-ex__voucher-price {
  flex: none;
  margin-left: auto;
  font-family: var(--mbr-font-headline);
  font-size: 16px;
  font-weight: 800;
  line-height: 22px;
  color: var(--mbr-color-ink-strong);
}

.mbr-ex__section {
  margin: 0 0 8px;
  font-size: var(--mbr-label-caps-size);
  font-weight: var(--mbr-label-caps-weight);
  line-height: var(--mbr-label-caps-line);
  letter-spacing: var(--mbr-label-caps-tracking);
  text-transform: uppercase;
  color: var(--mbr-color-ink-muted);
}

.mbr-ex__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-ex__value {
  min-width: 0;
  overflow: hidden;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mbr-ex__strong {
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 700;
  color: var(--mbr-color-ink-headline);
}

.mbr-ex__row--total {
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px dashed var(--mbr-color-outline);
  font-weight: 600;
}

.mbr-ex__total {
  font-family: var(--mbr-font-headline);
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--mbr-color-primary);
}

.mbr-ex__total--negative {
  color: var(--mbr-color-error);
}

.mbr-ex__error {
  margin: 12px 0 0;
  padding: 10px 14px;
  background: var(--mbr-color-error-container);
  border-radius: var(--mbr-radius-md);
  font-size: 13px;
  line-height: 18px;
  color: var(--mbr-color-error);
}

.mbr-ex__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 0 24px;
  background: var(--mbr-color-primary);
  border: 0;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 16px;
  font-weight: 700;
  color: var(--mbr-color-on-primary);
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.15s ease;
}

.mbr-ex__cta:active {
  transform: scale(0.98);
}

/* Bottom modal positioning */
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
  -webkit-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
  border-radius: 0;
  border: none;
}

.modal.modal-bottom .modal-body {
  padding: 15px;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}
</style>
